import { TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import axios from "axios";
import styles from "react-loading-overlay-ts/dist/styles";

export const formatNumber = (value: number | string) => {
    if (value == null || value === '') return '-'; // Handle null, undefined, or empty string
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return '-'; // Handle invalid number formats
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numericValue);
};

export function signout() {
    sessionStorage.clear();
    window.location.href = "/VU_HREC/";
  }

